// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"123":"f79158ba","908":"8e3cde7f"}[chunkId] + ".css";
};